import {Action, handleActions} from 'redux-actions';
import getValidXml from '@pluto/get-valid-xml';
import {INGEST_DATA_SET, INGEST_DATA_RESET} from './IngestDataActions';
import {
    IngestDataState,
    IngestDataPayload,
    Parents,
    ParentError,
    IngestDataError,
} from '../IngestDataTypes';

export const getParentsErrors = (parents?: Parents[]): undefined | ParentError[] => {
    if (!parents || !parents.length) return;

    const [{errors}] = parents;

    return errors;
};

export const getErrors = (
    parents?: Parents[],
    errors?: IngestDataError[] | ParentError[]
) => {
    if (errors?.length) return errors;

    return getParentsErrors(parents);
};

export const formatData = (payload: IngestDataPayload): IngestDataState => {
    const {
        feed,
        errors,
        title,
        parents,
        status,
        startTime,
        contentType,
        contentPartner,
        isEditable,
    } = payload;
    const {partnerName} = contentPartner;
    const {data, dataFormat} = feed;

    return {
        data: getValidXml(data),
        dataFormat,
        errors: getErrors(parents, errors),
        isEditable,
        title,
        status,
        startTime,
        contentType,
        partnerName,
        isLoaded: true,
    };
};

export const setIngestData = (
    state: IngestDataState,
    action: Action<IngestDataPayload | null>
): IngestDataState => {
    const {payload} = action;

    if (payload) return formatData(payload);

    return state;
};

export const resetIngestData = (): IngestDataState => {
    return initialState;
};

export const initialState = {
    data: null,
    dataFormat: '',
    isEditable: false,
    errors: [],
    title: null,
    status: '',
    startTime: '',
    contentType: '',
    partnerName: '',
    isLoaded: false,
};

const handlers = {
    [INGEST_DATA_SET]: setIngestData,
    [INGEST_DATA_RESET]: resetIngestData,
};

export default handleActions<IngestDataState, IngestDataPayload>(handlers, initialState);
